import { prefix, ajax } from './common';

export async function getNavMenus() {
  return await ajax({
    url: prefix + '/nav-menus',
  });
}